/**
 * Optional username + PIN account API (cross-device saved data).
 * See docs/spikes/optional-accounts-username-pin.md.
 */

import { api } from './client';

export interface AccountResponse {
  userId: string;
  username: string;
  accountToken: string;
  displayName?: string | null;
}

/** Advisory availability check (debounce from the caller). */
export async function checkUsername(username: string): Promise<boolean> {
  const res = await api.get<{ available: boolean }>('/v1/auth/username', {
    query: { u: username },
  });
  return res.available;
}

/** Claim an account on the current install row (keeps existing saved data). */
export function claimAccount(username: string, pin: string): Promise<AccountResponse> {
  return api.post<AccountResponse>('/v1/auth/account', { username, pin });
}

/** Sign in on another device — returns the portable account token. */
export function login(username: string, pin: string): Promise<AccountResponse> {
  return api.post<AccountResponse>('/v1/auth/login', { username, pin });
}

/** Rotate the PIN (authenticated). */
export function changePin(currentPin: string, newPin: string): Promise<void> {
  return api.post<void>('/v1/auth/pin', { currentPin, newPin });
}

/** Server-side logout (clears the web session cookie; client drops its token). */
export function logout(): Promise<void> {
  return api.post<void>('/v1/auth/logout');
}
